export default __webpack_public_path__ + "static/adam-e01b0ee59e51177bf0d1520a5d31e290.png";